export default function TengeSign() {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.2153 33.1832V16.6099H10.998V13.6032H32.998V16.6099H23.7808V33.1832H20.2153ZM10.998 7.51657H32.998V10.5232H10.998V7.51657Z"
        fill="currentColor"
      />
    </svg>
  );
}
